import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsMilitaryTime, IsNumber, IsOptional, Min } from 'class-validator';
import { StoreExposeGroup } from '../interface';
export class ReadStorePushOrdersToNextDayByValueDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadStorePushOrdersToNextDayByValueDto.prototype, "isEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: '14:36' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsMilitaryTime({ groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadStorePushOrdersToNextDayByValueDto.prototype, "startingTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 1 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.PATCH] }),
    Min(0, { groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadStorePushOrdersToNextDayByValueDto.prototype, "daysDelay", void 0);
//# sourceMappingURL=ReadStorePushOrdersToNextDayByValueDto.js.map